import { render } from "./PopUpRegister.vue?vue&type=template&id=420bb9a6"
import script from "./PopUpRegister.vue?vue&type=script&lang=js"
export * from "./PopUpRegister.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__